export const calcItemPrice = (item, config) => {
  if (!config || !item.service_type) return null;
  const service = config.services.find((s) => s.key === item.service_type);
  if (!service) return null;

  let base = 0;
  let sqftLabel = '';
  if (service.pricing === 'flat') {
    base = service.price;
  } else {
    const opt = config.sqft_options.find((o) => o.value === Number(item.square_feet));
    if (!opt) return null;
    base = item.service_type === 'deep' ? opt.deep_price : opt.regular_price;
    sqftLabel = opt.label;
  }

  const addonLines = Object.entries(item.add_ons || {})
    .map(([key, qty]) => {
      const cfg = config.add_ons.find((a) => a.key === key);
      if (!cfg) return null;
      const q = cfg.per_unit ? Math.max(1, qty) : 1;
      return { key, label: cfg.label, qty: q, total: cfg.price * q };
    })
    .filter(Boolean);

  const addonsTotal = addonLines.reduce((s, a) => s + a.total, 0);
  const freq = config.frequencies.find((f) => f.key === (item.frequency || 'one_time'));
  const discountRate = freq?.discount || 0;
  const discount = Math.round(base * discountRate * 100) / 100;

  return {
    base,
    addonLines,
    addonsTotal,
    discount,
    discountRate,
    total: base - discount + addonsTotal,
    serviceLabel: service.label,
    sqftLabel,
  };
};

export const formatMoney = (n) => `$${Number(n).toFixed(2).replace(/\.00$/, '')}`;
